module.exports = __webpack_public_path__ + "img/Google_Play_Store_badge_IT.b083c7b6.jpg";